import { Body } from '@/components/organisms/Admin/ProgressTypeform/Body'

export function ProgressTypeformPage() {
	return (
		<div className='flex flex-col'>
			<Body />
		</div>
	)
}
